/* */
import React, { useMemo, useRef } from 'react';
import { Col } from 'reactstrap';
import SliderTracker from 'components/SliderTracker';
import { Field, useFormikContext } from 'formik';
import InputField from 'customField/InputField';
import SwitchBoxField from 'customField/SwitchBoxField';
import NewDesign from 'components/NewDesign';

const domainValues = [50, 1000];

const AutoRecharge = ({ disableAutoRecharge }) => {
  //! State
  const isFirstRun = useRef(true);
  const { values, setFieldValue } = useFormikContext();
  const valueRecharge = useMemo(() => {
    return [values.rechargeVolume];
  }, [values.rechargeVolume]);

  //! Function
  const onChangeSlider = (val) => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }

    setFieldValue('rechargeVolume', val[0]);
  };

  //! Render
  return (
    <Col xs='12' md='12' className='checkout-form__auto-recharge'>
      <div className='checkout-form__auto-recharge__each-row'>
        <Field
          component={SwitchBoxField}
          name='autoRecharge'
          label={
            <NewDesign.Typography>
              Auto Recharge{' '}
              <NewDesign.Tooltip
                id='tooltip-auto-recharge'
                message={
                  <div>
                    <NewDesign.Typography component='p'>
                      The system will automatically charge the set amount when the current balance
                      is less than this amount.
                    </NewDesign.Typography>
                    <NewDesign.Typography>
                      For example, if you sets 101, then the system will auto charge $101 if your
                      balance {'<'} $101
                    </NewDesign.Typography>
                  </div>
                }
              />
            </NewDesign.Typography>
          }
          disabled={disableAutoRecharge}
        />
      </div>

      <div className='checkout-form__auto-recharge__each-row'>
        <label>Volume</label>
        <div className='slider-tracker' style={{ width: 400 }}>
          <SliderTracker
            domain={domainValues}
            onChange={onChangeSlider}
            values={valueRecharge}
            style={{ transform: 'translate(30px, 15px)' }}
            disabled={disableAutoRecharge || !values.autoRecharge}
          />
        </div>

        <Field
          type='number'
          name='rechargeVolume'
          component={InputField}
          style={{ maxWidth: 80 }}
          disabled={disableAutoRecharge || !values.autoRecharge}
        />
      </div>
    </Col>
  );
};
export default React.memo(AutoRecharge);
